export default "__VITE_ASSET__drFcaxCZ__"